import { render, staticRenderFns } from "./AlgoliaProxy.vue?vue&type=template&id=19348938"
import script from "./AlgoliaProxy.vue?vue&type=script&lang=js"
export * from "./AlgoliaProxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports